"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var material_1 = require("@mui/material");
var react_i18next_1 = require("react-i18next");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
var truncateText = function (text, maxLength) {
    return text.length > maxLength ? "".concat(text.substring(0, maxLength), "...") : text;
};
var formatMimeType = function (mimeType) {
    var _a;
    return mimeType ? (_a = mimeType.split("/").pop()) === null || _a === void 0 ? void 0 : _a.toUpperCase() : mimeType;
};
var formatConversions = function (conversions) {
    return Object.keys(conversions).filter(function (key) { return conversions[key]; }).join(", ");
};
var formatDate = function (dateString) {
    var date = new Date(dateString);
    var hours = date.getHours().toString().padStart(2, "0");
    var minutes = date.getMinutes().toString().padStart(2, "0");
    var day = date.getDate().toString().padStart(2, "0");
    var month = (date.getMonth() + 1).toString().padStart(2, "0");
    var year = date.getFullYear();
    return "".concat(hours, ":").concat(minutes, " - ").concat(day, ".").concat(month, ".").concat(year);
};
var MediaDetailsDialog = function (_a) {
    var _b, _c;
    var open = _a.open, onClose = _a.onClose, media = _a.media, anchorEl = _a.anchorEl, viewType = _a.viewType;
    var t = (0, react_i18next_1.useTranslation)().t;
    if (!media)
        return null;
    var dialogPosition = anchorEl ? {
        top: viewType === "grid" ? anchorEl.getBoundingClientRect().top - 130 : anchorEl.getBoundingClientRect().top - 130,
        left: viewType === "grid" ? anchorEl.getBoundingClientRect().right - 105 : anchorEl.getBoundingClientRect().right - 450,
    } : {};
    return (react_1.default.createElement(material_1.Dialog, { open: open, onClose: onClose, PaperProps: {
            sx: __assign(__assign({ position: "absolute" }, dialogPosition), { width: "270px", height: "290px", borderRadius: "14px", overflow: "visible" })
        }, slotProps: { backdrop: { invisible: true } }, fullWidth: true, sx: { borderRadius: "14px" } },
        react_1.default.createElement(material_1.IconButton, { "aria-label": "close", onClick: onClose, sx: {
                background: "var(--close-btn-color)",
                borderRadius: "50%",
                width: "35px",
                height: "35px",
                fontSize: "24px",
                cursor: "pointer",
                position: "absolute",
                right: -10,
                top: -5,
                zIndex: 10,
                "&:hover": {
                    background: "var(--close-btn-color)",
                },
            } },
            react_1.default.createElement("div", { "data-cy": "modalCloseBtn" },
                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faXmark, style: { color: "var(--info-color)" } }))),
        react_1.default.createElement(material_1.DialogTitle, { sx: { color: "var(--info-color)", fontFamily: "Geomanist-bold" } }, t("Description")),
        react_1.default.createElement(material_1.DialogContent, { sx: { fontSize: "12px", overflow: "hidden" } },
            react_1.default.createElement("p", null,
                react_1.default.createElement("span", { style: { opacity: 0.6 } },
                    t("Uploaded on"),
                    ":"),
                " ",
                formatDate(media.created_at)),
            react_1.default.createElement("p", null,
                react_1.default.createElement("span", { style: { opacity: 0.6 } },
                    t("File size"),
                    ":"),
                " ",
                media.size),
            react_1.default.createElement("p", null,
                react_1.default.createElement("span", { style: { opacity: 0.6 } },
                    t("File type"),
                    ":"),
                " ",
                formatMimeType(media.mime_type)),
            react_1.default.createElement("p", { title: media.file_name },
                react_1.default.createElement("span", { style: { opacity: 0.6 } },
                    t("File name"),
                    ":"),
                " ",
                truncateText(media.file_name, 30)),
            react_1.default.createElement("p", null,
                react_1.default.createElement("span", { style: { opacity: 0.6 } },
                    t("Uploaded by"),
                    ":"),
                " ", (_c = (_b = media.custom_properties) === null || _b === void 0 ? void 0 : _b.uploaded_by) === null || _c === void 0 ? void 0 :
                _c.name),
            react_1.default.createElement("p", null,
                react_1.default.createElement("span", { style: { opacity: 0.6 } },
                    t("File conversions"),
                    ":"),
                " ",
                formatConversions(media.generated_conversions)))));
};
exports.default = MediaDetailsDialog;
